import { FieldValues, useFormContext, useWatch } from 'react-hook-form';

const useFormValues = (): FieldValues => {
  const { getValues } = useFormContext();

  return {
    ...useWatch(),
    ...getValues(),
  };
};

export default useFormValues;
